/**
 * Parcels Details
 */

// React
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";

// Context
import AuthContext from "../../authContext";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { Store } from "../../redux/reducers";
import {
  getLogsAction,
  getParcelsWithIdAction,
  getParcelInventoryItemsAction,
  cleanPercelInventoryItemsAction,
  getInventoryItemsWithSerialAction,
} from "../parcels/actions";

// Selector
import { createStructuredSelector } from "reselect";
import {
  makeSelectLogs,
  makeSelectParcel,
  makeSelectLoading,
  makeSelectError,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
  makeSelectInventoryItemsCount,
  makeSelectInventoryItemsWithSerialList,
  makeSelectInventoryItemsWithSerialLoading,
} from "../parcels/selectors";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import theme from "../../theme";
import {
  Typography,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Box,
  ClickAwayListener,
  IconButton,
  Collapse,
  Card,
  CardHeader,
  CardContent,
  FormControl,
  FormControlLabel,
  Select,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";

// Icon
import Icon from "@mdi/react";
import {
  mdiStateMachine,
  mdiKeyOutline,
  mdiAccountOutline,
  mdiWarehouse,
  mdiArrowRight,
  mdiFormatListCheckbox,
  mdiPackage,
  mdiPhoneOutline,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiArchiveOutline,
  mdiFormatListBulleted,
  mdiCityVariant,
  mdiCounter,
  mdiChevronUp,
  mdiChevronDown,
  mdiDotsHorizontalCircleOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardCheckOutline,
  mdiClose,
  mdiFileTree,
  mdiPlaylistCheck,
  mdiArrowCollapseAll,
  mdiCheckBold,
  mdiClipboardArrowLeft,
  mdiTableCheck,
  mdiTableArrowUp,
} from "@mdi/js";

// Components
import ListParcelItems from "./list";
import Can from "../../components/Can";
import CSV from "./csv";
import InventoryItemCSV from "./inventoryItemCsv";
import LabelList from "../parcelInventoryItems/components/labelsList";
import Modal from "../../components/Modal";

// Helper
import {
  translateUserRoles,
  translateParcelsStatus,
  formaterPhoneNumber,
  removeEmptyValueObject,
} from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Type
import { Status } from "../orders/interfaces";
import { SelectorProps, Props } from "./interfaces";
import Pagination from "@material-ui/lab/Pagination";
import RenderFilter, { Filter } from "../../utils/listDaynamicFilter";
import clsx from "clsx";
import useQuery from "../../utils/hook/useQuery";
import { getAllTicket } from "../../api/ticket/get";
import handleError from "../../utils/handleError";
import CustomizedItemsCard from "./customizedItemsCard";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: "16px",
      marginBottom: "16px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
    },

    item: {
      marginBottom: "30px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    iconButton: {
      padding: 8,
      marginRight: "10px",
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "1px",
        height: "36px",
        top: "4px",
        left: "-9px",
        backgroundColor: "#EDF1F4",
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: "absolute",
      backgroundColor: "#fff",
      width: "70%",
      marginTop: "30px",
      top: "180px",
      right: "33px",
      borderRadius: "0  0 4px  4px",
      padding: "16px 16px",
      boxSizing: "border-box",
      boxShadow: "0px 2px 4px 1px rgba(0,0,0,0.1)",
      zIndex: 10,
    },
    filterOpen: {
      display: "block",
    },
    label: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      color: "#8A8A8A",
      marginRight: "auto",
    },

    headerBox: {
      marginLeft: "75px",
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
      marginTop: "20px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#fff",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    collapseIcon: {
      marginTop: "-36px",
      textAlign: "center",
      position: "relative",
      width: "100%",
      // marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "40px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: theme.palette.secondary.main,
        border: "5px solid white",
      },
    },
    MuiFormHelperText: {
      "& ": {
        display: "none",
      },
    },
    typographyCards: {
      fontSize: "16px",
      color: "white",
      backgroundColor: "#4BCF90",
      paddingTop: "8px",
      paddingRight: "24px",
      paddingBottom: "8px",
      paddingLeft: "50px",
      marginLeft: "-40px",
    },
    cardContent: {
      paddingLeft: "14px",
    },
    card: {
      marginBottom: "32px",
      overflow: "visible",
      padding: "14px",
    },
    cardDivider: {
      width: "100%",
      marginRight: "0 auto",
    },
    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      "@media (min-width: 768px)": {
        width: "40%",
      },
      alignItems: "center",
    },

    titleBox: {
      paddingTop: "10px",
    },
    contentBox: {
      marginTop: "-20px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(2),
      fontSize: "14px",
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },
  })
);

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  CANCELLED: mdiClose, //'لغو شده',
  SHIPPED: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  SUBMITTED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  ASSIGNED: mdiPlaylistCheck, // تخصیص داده شده
  REGISTERED: mdiCheckBold, //'منطبق شده',
  CONFLICTED: mdiArrowCollapseAll, // مغایرت داده شده
  LOCATED: mdiFileTree, // جایگذاری شده
  RETURNING: mdiClipboardArrowLeft, // ریجکت شده
  UNLOADING: mdiTableArrowUp, // در حال بارگذاری
  UNLOADED: mdiTableCheck, // بارگذاری شده
};
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'بارگذاری شده',
  LOCATED: "purple", // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main, // مغایرت داده شده
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery(
    {
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 10000,
    } as any,
    ""
  );
  const [open, setOpen] = React.useState(false);
  const [printModal, setPrintModal] = useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [oldTicket, setOldTicket] = useState([]);
  const classes = useStyles();

  const setupFilters = () => {
    setFilters([
      {
        type: "input",
        id: "productName.contains",
        label: "نام کالا",
        icon: mdiArchiveOutline,
      },
      {
        type: "input",
        id: "productCode.contains",
        label: "کد کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "number",
        id: "productId.equals",
        label: "شناسه کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "number",
        id: "skuId.equals",
        label: "شناسه تنوع کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "input",
        id: "skuCode.contains",
        label: "کد تنوع کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "input",
        id: "serialNumber.equals",
        label: "سریال کالا",
        icon: mdiKeyOutline,
      },
    ]);
  };

  const getOldTicket = async (id: number) => {
    try {
      const res = await getAllTicket({ linkType: "parcel", linkId: id });
      setOldTicket(res.data.content);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    const { id } = props.match.params;
    props.getLogsDispatch(id);

    props.getParcelWithIdActionDispatch(id);
    props.getInventoryItemsWithSerialActionDispatch({
      ...filtersValues,
    });
    getOldTicket(id);
    return () => {
      props.clearnParcelInventoryItemsDispatch();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.getParcelInventoryItemDispatch({
      ...filtersValues,
    });
    setupFilters();
  }, [filtersValues]);

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleClickFilter = () => {
    setOpenFilterBox((prev) => !prev);
  };

  useEffect(() => {
    setFiltersValues({
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 10000,
    });
  }, [printModal]);

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute("dir") !== "rtl" &&
      e.target.getAttribute("type") !== "checkbox" &&
      e.target.getAttribute("class") !== "PrivateSwitchBase-input-73" &&
      e.target.getAttribute("class") !==
        "MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock" &&
      e.target.getAttribute("aria-hidden") !== "true"
    )
      setOpenFilterBox(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.inventoryItems.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(",")}`
    );
  };

  return (
    <div className={classes.root}>
      <Grid
        style={{
          zIndex: 2,
          backgroundColor: "white",
          position: "fixed",
          top: "0",
          right: "75px",
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center">
        <div className={classes.headerBox}>
          <Typography variant="h6" component="h2">
            {`
        جزيیات محموله 
        ${props.parcel.destinationName}
        `}
          </Typography>
        </div>
      </Grid>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center">
        <Button
          style={{ marginBottom: "32px", marginTop: "32px" }}
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}>
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {"بازگشت"}
        </Button>
      </Grid>

      <Grid container item lg={12} md={12} spacing={4}>
        <Grid item lg={3} md={3} spacing={2}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات محموله
                </Typography>
              }
            />
            <CardContent>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نوع ارسال:"}</span>
                  <span>{props.parcel?.courierName || "-"}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نوع ورود:"}</span>
                  <span>{props.parcel?.fulfillmentTypeName || "-"}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{"وضعیت تحویل :  "}</span>
                  <span>{translateParcelsStatus(props.parcel.status)}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نام شرکت:  "}</span>
                  <span>
                    {props.parcel.partnerName ?? props.parcel.sellerName}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {"تعداد آیتم های محموله:  "}
                  </span>

                  <span>{props.inventoryItemsCount}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"شناسه محموله:  "}</span>

                  <span>{props.parcel.id}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"تاریخ ثبت محموله:  "}</span>
                  <span>
                    <span>
                      {props.parcel.deliveryDate &&
                        `${jMoment(props.parcel.shippingDate, "YYYY/MM/DD")
                          .locale("fa")
                          .format("jYYYY/jMM/jDD")}`}
                    </span>
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"تعداد تنوع کالا:  "}</span>

                  <span>{props.parcel?.items?.length}</span>
                </div>
              </Grid>

              <Divider style={{ width: "100%", marginBottom: "24px" }} />
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد بسته:"}</span>
                <span style={{ flex: 1, maxWidth: "200px" }}>
                  {props.parcel?.parcelPackages?.map((el: any) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}>
                      <span className="ml-1">{el?.count}</span>
                      <span className="ml-1">{`${el.length}×${el.height}×${el.width}`}</span>
                      <span>{el.weight}</span>
                    </div>
                  ))}
                </span>
              </div>

              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {"تاریخ تحویل به انبار:  "}
                  </span>
                  <span>
                    <span>
                      {props.parcel.shippingDate &&
                        `${jMoment(props.parcel.deliveryDate, "YYYY/MM/DD")
                          .locale("fa")
                          .format("jYYYY/jMM/jDD")}`}
                    </span>
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {"بازه تحویل محموله:  "}
                  </span>
                  <span>
                    <span>
                      {props.parcel.deliveryStartTime &&
                        jMoment(props.parcel.deliveryStartTime, "hh:mm")
                          .locale("fa")
                          .format("HH:mm")}
                      {" - "}
                      {props.parcel.deliveryEndTime &&
                        jMoment(props.parcel.deliveryEndTime, "hh:mm")
                          .locale("fa")
                          .format("HH:mm")}
                    </span>
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات انبار مقصد
                </Typography>
              }
            />
            <CardContent>
              <Grid xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{"انبار مقصد:  "}</span>

                  <span>{props.parcel.destinationName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"آدرس انبار مقصد :  "}</span>
                  <span style={{ fontSize: "14px", textAlign: "left" }}>
                    {props.parcel.destinationAddress}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات مسئول حمل
                </Typography>
              }
            />
            <CardContent>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نام  :  "}</span>

                  <span>{props.parcel.agentName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"شماره تماس  :  "}</span>
                  <span>
                    {formaterPhoneNumber(props.parcel.agentPhoneNumber)}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={9} md={9} spacing={2}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  خدمات پیشرفته ورود
                </Typography>
              }
            />
            <CardContent style={{ margin: "15px 0  0", padding: "0" }}>
              <Grid spacing={3} container>
                <CustomizedItemsCard
                  parcel={props.parcel}
                  userRole={authContext.user.role}
                />
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست کالاهای محموله
                </Typography>
              }
              action={
                <Grid item xs={12} style={{ marginTop: "15px" }}>
                  <div style={{ textAlign: "left" }}>
                    <Can
                      role={authContext.user.role}
                      perform="/parcels/receipts/:id"
                      yes={() => (
                        <Link
                          to={`/parcels/receipts/${props.parcel.id}`}
                          target="_blank"
                          style={{ textDecoration: "none" }}>
                          <Button
                            style={{ marginLeft: "5px" }}
                            variant="contained"
                            color="secondary">
                            {authContext.user.role === "WAREHOUSE_OPERATOR" ||
                            authContext.user.role === "WAREHOUSE_ADMIN"
                              ? "چاپ رسید"
                              : "چاپ حواله"}
                          </Button>
                        </Link>
                      )}
                    />
                    <Can
                      perform="parcels-details:print"
                      role={authContext.user.role}
                      yes={() => (
                        <Button
                          variant="contained"
                          color="primary"
                          size="medium"
                          // startIcon={<Icon path={mdiPrinter} size={1} />}
                          onClick={handleOpenPrintModal}
                          style={{ marginLeft: "5px" }}>
                          {"چاپ سریال"}
                        </Button>
                      )}
                    />
                    <Can
                      role={authContext.user.role}
                      perform="parcels-detail:downloadInventoryItemCSV"
                      yes={() => (
                        <>
                          {props.inventoryItemsWithSerial?.length && (
                            <InventoryItemCSV
                              ordersDispatch={
                                props.getInventoryItemsWithSerialActionDispatch
                              }
                              data={props.inventoryItemsWithSerial}
                              filtersValues={filtersValues}
                              loading={props.inventoryItemsWithSerialLoading}
                            />
                          )}
                        </>
                      )}
                    />
                    <Can
                      role={authContext.user.role}
                      perform="parcels-detail:downloadCSV"
                      yes={() => (
                        <>
                          {props.parcel?.items?.length && (
                            <CSV
                              ordersDispatch={
                                props.getParcelInventoryItemDispatch
                              }
                              data={props.parcel?.items}
                              filtersValues={filtersValues}
                              loading={props.inventoryItemsLoading}
                            />
                          )}
                        </>
                      )}
                    />
                    {oldTicket.length > 0 && (
                      <Link to={`/ticketing/${oldTicket[0].id}`}>
                        <Button
                          variant="contained"
                          size="large"
                          color="primary"
                          style={{ marginLeft: "5px" }}>
                          {`سابقه تیکت`}
                        </Button>
                      </Link>
                    )}
                  </div>
                </Grid>
              }
            />
            <CardContent style={{ margin: "15px 0  0", padding: "0" }}>
              <Grid spacing={3} container>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  props.parcel?.items && (
                    <>
                      <ListParcelItems data={props.parcel.items} />
                    </>
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه سفارش
                </Typography>
              }
            />
            <CardContent style={{ margin: "14px 0 0 0", padding: "0" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Timeline align="left">
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}>
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? "solid 4px #DF9234" : "",
                              }}>
                              <Icon path={iconStatus[log.newStatus]} size={1} />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ""
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div className={classes.contentBox}>
                              <div>
                                <span className={classes.contentlabel}>
                                  وضعیت محموله:
                                </span>
                                <span>
                                  {translateParcelsStatus(log.newStatus)}
                                </span>
                              </div>
                              <div style={{ marginTop: "12px" }}>
                                <span className={classes.contentlabel}>
                                  کاربر:
                                </span>
                                <Can
                                  role={authContext.user.role}
                                  perform="user-name:dontShowInLogs"
                                  no={() => (
                                    <>
                                      <span>{log.modifierName}</span>
                                      <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                                    </>
                                  )}
                                />
                                <span>
                                  {translateUserRoles(log.modifierRole)}
                                </span>
                              </div>
                              <Typography
                                component="div"
                                className={classes.titleBox}>
                                {log.time &&
                                  jMoment(log.time, "YYYY/MM/DDTHH:mm:ss.SSZ")
                                    .locale("fa")
                                    .format("jYYYY/jMM/jDD - HH:mm")}
                              </Typography>
                              {log.description && (
                                <div style={{ marginTop: "12px" }}>
                                  <span className={classes.contentlabel}>
                                    توضیحات:
                                  </span>
                                  <span>{log.description}</span>
                                </div>
                              )}
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={3} md={3} spacing={2}></Grid>
      </Grid>

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              style={{ marginBottom: "5px" }}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search">
                    {openFilterBox ? "بستن" : "جستجوی پیشرفته"}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}>
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: "20px", marginTop: "20px" }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={props.inventoryItems}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="space-between" alignItems="center">
              <Pagination
                count={Math.ceil(
                  props.inventoryItemsCount / filtersValues.size
                )}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}>
                {"پرینت سریال‌ها"}
              </Button>
            </Grid>
          </Grid>
        }
      />
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),

  parcel: makeSelectParcel(),
  loading: makeSelectLoading(),
  inventoryItemsCount: makeSelectInventoryItemsCount(),
  inventoryItemsWithSerial: makeSelectInventoryItemsWithSerialList(),
  inventoryItemsWithSerialLoading: makeSelectInventoryItemsWithSerialLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsList(),
  inventoryItemsLoading: makeSelectInventoryItemsLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),

    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    getParcelInventoryItemDispatch: (payload: object) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    clearnParcelInventoryItemsDispatch: () =>
      dispatch(cleanPercelInventoryItemsAction()),
    getInventoryItemsWithSerialActionDispatch: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
